<template>
  <div class="container">
    <FirstAdd ref="firstAdd" v-show="pagination.total == '0' && !name"></FirstAdd>
    <template v-if="!(pagination.total == '0' && !name)">
      <div class="header" v-if="pagination.total > 0 || name">
        <a-input-search allowClear v-model="name" :placeholder="$t('enterCourseName')" @change="onSearch">
          <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
          <img
            class="clear"
            v-if="name"
            slot="suffix"
            @click=";(name = undefined), onSearch()"
            :src="require('@/assets/icons/icon_gb.png')"
          />
          <a-button class="search-btn" slot="enterButton">
            {{ $t('courses.search') }}
          </a-button>
        </a-input-search>
        <div class="btns">
          <a-button type="primary" class="gray" @click="generationCourse" v-if="hasPermission('teacher_ai_chat')">
            {{ $t('courses.intelligentCourseGeneration') }}
          </a-button>
          <a-button type="primary" class="gray" @click="importCourse">
            {{ $t('importCourse') }}
          </a-button>
          <a-button type="primary" @click="createCourse">{{ $t('createCourse') }}</a-button>
          <FirstAdd ref="firstAddShade" type="shade"></FirstAdd>
        </div>
      </div>
      <div class="list" v-if="pagination.total > 0">
        <div class="item" v-for="item in list" :key="item.key">
          <div class="icon-top" v-if="item.isTop">{{ $t('top') }}</div>
          <img class="cover" v-if="item.cover" :src="item.cover" alt="" srcset="" />
          <img class="cover" v-else src="@/assets/img/pic_kc@2x.png" alt="" srcset="" />
          <div class="bottom">
            <a-tooltip class="left">
              <template slot="title">
                {{ item.name }}
              </template>
              {{ item.name }}
            </a-tooltip>
            <div class="right">
              <a-dropdown-button @click="edit(item.id)">
                <a-tooltip class="title">
                  <template slot="title">
                    {{ $t('editCourse') }}
                  </template>
                  <img
                    @mouseenter="editId = item.id"
                    @mouseleave="editId = -1"
                    :src="
                      editId == item.id ? require('@/assets/img/icon_bj_x.png') : require('@/assets/img/icon_bj.png')
                    "
                  />
                </a-tooltip>
                <a-menu slot="overlay">
                  <a-menu-item @click="rename(item.id, item.name)">{{ $t('rename') }}</a-menu-item>
                  <a-menu-item @click="copy(item.id)">{{ $t('copy') }}</a-menu-item>
                  <a-menu-item @click="toTop(item)">{{ item.isTop ? $t('cancelTop') : $t('setTop') }}</a-menu-item>
                  <a-menu-item @click="delModal(item.id)">{{ $t('delete') }}</a-menu-item>
                </a-menu>
              </a-dropdown-button>
            </div>
            <div class="time">{{ item.createdAt }}</div>
          </div>
          <div class="shade" @click.stop="startClass(item.id)">
            <div class="button">{{ $t('startClass') }} ></div>
          </div>
        </div>
      </div>
      <div class="nodata" :class="{ full: !name }" v-else>
        <img src="@/assets/img/bj_zanwu_2.png" alt="" srcset="" />
        <div>
          <div>{{ $t('noCourseData') }}</div>
          <a-button type="primary" v-if="!name" class="lesson-add" @click="createCourse">{{ $t('createCourse') }}</a-button>
          <div v-else>{{ $t('tryAnotherKeyword') }}</div>
        </div>
      </div>
      <Pagination class="list-pagination" :pagination.sync="pagination" @handleTableChange="handleTableChange" />
      <a-modal :title="$t('renameCourseInfo')" :visible="visible" @ok="ok" @cancel="visible = false">
        <span>*</span>{{ $t('courseName') }}：<a-input
          maxLength="15"
          allowClear
          v-model="replaceName"
          :placeholder="$t('courseNamePlaceholder')"
        />
      </a-modal>
      <TipModal
        @ok="del"
        :visible="delVisible"
        @cancel="delVisible = false"
        :desc="
          `
          <p></p>
          <p>${$t('confirmDeleteCourse')}</p>
          <p class='placeholder'>${$t('deleteReportWarning')}</p>`
        "
      />
    </template>
    <StartClass ref="startClass" />
  </div>
</template>

<script>
import {
  prepareLessonList,
  prepareLessonCopy,
  prepareLessonRename,
  prepareLessonSetTop,
  prepareLessonDelete
} from '@/api/lesson'
import FirstAdd from './components/firstAdd.vue'
import StartClass from './components/StartClass.vue'
import TipModal from '@/components/tipModal/index.vue'
import Pagination from '@/components/pagination/index.vue'
import screenfull from 'screenfull'

export default {
  components: {
    FirstAdd,
    StartClass,
    TipModal,
    Pagination
  },
  data() {
    return {
      editId: -1,
      name: undefined,
      visible: false,
      delId: undefined,
      delVisible: false,
      replaceName: undefined,
      list: [
        {
          id: 1,
          phase: '中职',
          name: '课程名称1',
          status: '已结束',
          top_status: true,
          courseLength: '01:30',
          end_time: '23-08-15 12:00',
          start_time: '23-08-15 10:30'
        },
        {
          id: 2,
          phase: '中职',
          name: '课程名称2',
          status: '待授课',
          courseLength: '02:00',
          end_time: '23-11-15 12:00',
          start_time: '23-11-15 10:00'
        },
        {
          id: 3,
          phase: '中职',
          name: '课程名称3',
          status: '待授课',
          courseLength: '02:00',
          end_time: '23-11-15 12:00',
          start_time: '23-11-15 10:00'
        },
        {
          id: 4,
          phase: '中职',
          name: '课程名称4',
          status: '待授课',
          courseLength: '02:00',
          end_time: '23-11-15 12:00',
          start_time: '23-11-15 10:00'
        },
        {
          id: 5,
          phase: '中职',
          name: '课程名称5',
          status: '待授课',
          courseLength: '02:00',
          end_time: '23-11-15 12:00',
          start_time: '23-11-15 10:00'
        },
        {
          id: 6,
          phase: '中职',
          name: '课程名称6',
          status: '待授课',
          courseLength: '02:00',
          end_time: '23-11-15 12:00',
          start_time: '23-11-15 10:00'
        }
      ],
      columns: [
        {
          title: 'ID',
          key: 'id',
          dataIndex: 'id'
        },
        {
          title: this.$t('courses.courseName'),
          key: 'name',
          dataIndex: 'name'
        },
        {
          title: this.$t('courses.class'),
          key: 'phase',
          dataIndex: 'phase'
        },
        {
          title: this.$t('courses.startTime'),
          key: 'start_time',
          dataIndex: 'start_time'
        },
        {
          title: this.$t('courses.endTime'),
          key: 'end_time',
          dataIndex: 'end_time'
        },
        {
          title: this.$t('courses.courseLength'),
          key: 'courseLength',
          dataIndex: 'courseLength'
        },
        {
          title: this.$t('courses.status'),
          key: 'status',
          dataIndex: 'status'
        },
        {
          title: this.$t('courses.operation'),
          key: 'operate',
          dataIndex: 'operate',
          scopedSlots: { customRender: 'operate' }
        }
      ],
      pagination: {
        page: 1,
        total: 0,
        pageSize: 15
      }
    }
  },
  methods: {
    onSearch() {
      this.pagination.page = 1
      this.getPrepareLessonList()
    },
    startClass(id) {
      this.$refs.startClass.selectClass(id)
    },
    edit(id) {
      this.$router.push({
        name: 'addCourses',
        query: {
          id
        }
      })
    },
    rename(id, name) {
      this.visible = true
      this.replaceId = id
      this.replaceName = name
    },
    ok() {
      if (!this.replaceName) {
        this.$message.error(this.$t('courseNameRequired'))
        return
      }
      prepareLessonRename({
        id: this.replaceId,
        name: this.replaceName
      }).then(res => {
        if (res.code == 200) {
          this.$message.success(this.$t('saveSuccess'))
          this.pagination.page = 1
          this.getPrepareLessonList()
          this.visible = false
        }
      })
    },
    copy(id) {
      prepareLessonCopy({ id }).then(res => {
        if (res.code == 200) {
          this.pagination.page = 1
          this.getPrepareLessonList()
          this.$message.success(this.$t('copySuccess'))
        }
      })
    },
    toTop(item) {
      prepareLessonSetTop({
        id: item.id,
        status: !item.isTop
      }).then(res => {
        if (res.code == 200) {
          this.$message.success(item.isTop ? this.$t('topCancelSuccess') : this.$t('topSuccess'))
          this.pagination.page = 1
          this.getPrepareLessonList()
        }
      })
    },
    delModal(id) {
      this.delVisible = true
      this.delId = id
    },
    del() {
      prepareLessonDelete({ id: this.delId }).then(res => {
        if (res.code == 200) {
          this.$message.success(this.$t('deleteSuccess'))
          this.delVisible = false
          this.delId = undefined
          this.pagination.page = 1
          this.getPrepareLessonList()
        }
      })
    },
    handleTableChange() {
      this.getPrepareLessonList()
    },
    getPrepareLessonList() {
      const data = {
        name: this.name,
        page: this.pagination.page,
        pageSize: this.pagination.pageSize
      }
      prepareLessonList(data).then(res => {
        if (res.code != 200) return
        this.list = res.data.list
        this.pagination.total = res.data.total
      })
    },
    importCourse() {
      this.$refs.firstAddShade.show = true
    },
    // --------------------------------------------------------------------------------
    createCourse() {
      this.$router.push({
        name: 'addCourses'
      })
    },
    goAttendClass() {
      document.documentElement.requestFullscreen()
      this.$router.push({
        name: 'teaching',
        query: {
          id: 195
        }
      })
      // if (screenfull.isEnabled) {
      //   screenfull.request() // 默认全屏显示
      // }
    },
    goLessonList(id) {
      this.$router.push({
        name: 'lessonList',
        query: {
          id
        }
      })
    },
    goTutorialRelease(id) {
      this.$router.push({
        name: 'tutorialRelease',
        query: {
          id
        }
      })
    },
    shareToPortal(id) {
      this.$router.push({
        name: 'shareToPortal',
        query: {
          lessonId: id
        }
      })
    },
    generationCourse() {
      this.$router.push({
        name: 'generationCourse'
      })
    },
    hasPermission(tag) {
      const permissionList = localStorage.permissionList || '[]'
      return permissionList && permissionList.includes(tag)
    }
  },
  mounted() {
    this.getPrepareLessonList()
  }
}
</script>

<style lang="less" scoped>
.container {
  position: relative;
  /deep/ .ant-table {
    min-height: 583px;
  }
  .list-pagination {
    width: 100%;
    height: auto;
    // bottom: 50px;
    position: absolute;
  }
  .btns {
    /deep/ .ant-btn {
      margin-left: 10px;
    }
    .gray {
      background: linear-gradient(248deg, #72899d 0%, #9bb3c8 100%);
    }
  }
}
h4 {
  padding: 20px 28px 0 19px;
}
p {
  font-size: 12px;
  font-weight: 400;
  color: #687f9c;
  margin-bottom: 0;
  line-height: 17px;
  padding: 0 28px 0 19px;
}
.header {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 46px 28px 22px 19px;
  justify-content: space-between;
  /deep/.ant-input-group-wrapper {
    width: 330px;
    height: 35px;
    .ant-input-prefix {
      // right: auto;
      left: 16px;
      img {
        width: 16px;
      }
    }
    .ant-input-suffix {
      right: 0;
      .anticon.anticon-close-circle.ant-input-clear-icon {
        display: none;
      }
      .clear {
        width: 14px;
        height: 14px;
        cursor: pointer;
      }
    }
    .ant-input-search {
      height: 35px;
      .ant-input {
        height: 35px;
        color: #000;
        padding-left: 46px;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        border-color: #d8dce0;
        box-shadow: none;
      }
    }
    .ant-input-group-addon .search-btn {
      border-left: 0;
      height: 35px;
      border-color: #d8dce0;
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
      span {
        display: flex;
        font-size: 14px;
        color: #333333;
        position: relative;
        align-items: center;
        &::before {
          left: -8px;
          content: '';
          width: 1px;
          height: 15px;
          background: #e9e9e9;
          position: absolute;
        }
      }
    }
    // border: 1px solid #D8DCE0;
  }
}
.list {
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
  padding: 12px 28px 0 19px;
  max-height: calc(100% - 150px);
  .item {
    width: calc((100% - 88px) / 5);
    margin-top: 18px;
    margin-right: 22px;
    position: relative;
    display: inline-block;
    .icon-top {
      top: 6px;
      left: 0;
      position: absolute;
      width: 59px;
      height: 26px;
      background: linear-gradient( 69deg, #FFE8B3 0%, #FFEFCB 100%);
      border-radius: 0px 6px 6px 0px;
      text-align: center;
      line-height: 26px;
      color: #533A00;
      font-size: 12px;
    }
    .cover {
      width: 100%;
      height: 172px;
      cursor: pointer;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }
    .bottom {
      display: flex;
      flex-wrap: wrap;
      cursor: pointer;
      padding: 12px 0px 12px 4px;
      align-items: flex-start;
      justify-content: space-between;
      .left {
        color: #000;
        font-weight: 550;
        overflow: hidden;
        text-wrap: nowrap;
        margin-bottom: 2px;
        display: inline-block;
        text-overflow: ellipsis;
        width: calc(100% - 80px);
      }
      .right {
        margin-top: 2px;
        /deep/.ant-btn-group {
          display: flex;
          align-items: center;
          .ant-btn {
            height: 21px;
            display: flex;
            padding-right: 12px;
            align-items: center;
            &:last-child {
              padding-right: 3px;
              padding-left: 3px;
              border-radius: 2px;
            }
          }
        }
        img {
          width: 16px;
          height: 16px;
        }
      }
      .time {
        width: 100%;
        color: #666666;
        font-size: 12px;
      }
    }
    &:nth-child(-n + 5) {
      margin-top: 0;
    }
    &:nth-child(5n) {
      margin-right: 0;
    }
    .shade {
      top: 0;
      left: 0;
      width: 100%;
      height: calc(100% - 65px);
      display: flex;
      opacity: 0;
      cursor: pointer;
      border-radius: 6px;
      position: absolute;
      align-items: center;
      justify-content: center;
      background: rgba(0, 0, 0, 0.6);
      .button {
        min-width: 80px;
        height: 30px;
        padding: 0 6px;
        font-size: 12px;
        font-weight: 400;
        color: #ffffff;
        line-height: 30px;
        text-align: center;
        background: linear-gradient(248deg, #ff6d00 0%, #f5a623 100%);
        box-shadow: 0px 0px 3px 0px rgba(204, 76, 26, 0.12);
        border-radius: 6px;
      }
    }
    .shade:hover {
      opacity: 1;
    }
  }
  /deep/.ant-btn-default,
  .ant-dropdown-trigger {
    border: 0;
    color: #000000;
    box-shadow: none;
    border: 1px solid #fff;
  }
  /deep/.ant-dropdown-trigger.ant-dropdown-open {
    color: #ff6d00;
    background: #ffedea;
    border: 1px solid #ff6d00;
  }
}
.list::-webkit-scrollbar {
  display: none;
}

/deep/.ant-modal {
  .ant-modal-body {
    color: #000;
    font-size: 14px;
    span:first-child {
      color: red;
      margin-right: 6px;
    }
    .ant-input-affix-wrapper {
      // width: 300px;
      margin-top: 6px;
      .ant-input {
        color: #000;
      }
    }
  }
  .ant-modal-footer {
    text-align: center;
    .ant-btn-primary {
      margin-left: 50px;
    }
  }
}
.nodata {
  display: flex;
  position: relative;
  align-items: center;
  padding: 150px 100px;
  flex-direction: column;
  justify-content: center;
  height: calc(100% - 103px);
  img {
    width: 285px;
    // height: 300px;
    margin-bottom: 50px;
  }
  > div {
    width: 100%;
    display: flex;
    margin-top: -70px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    div {
      color: #0d2340;
      cursor: pointer;
      font-weight: 550;
      margin-left: 10px;
      font-size: 14px;
      position: relative;
      &:last-child {
        font-weight: 500;
        font-size: 12px;
      }
    }
    .lesson-add {
      cursor: pointer;
      font-weight: 500;
      margin-left: 10px;
      margin-top: 12px;
    }
  }
}
.full.nodata {
  height: 100%;
}
.item:hover {
  .bottom .left {
    color: #ff6d00 !important;
  }
}
/deep/.ant-dropdown-menu-item {
  text-align: center;
  &:hover {
    color: #ff6d00;
    background: none;
  }
}
</style>
